import Localized from "../../../Localized";
import './style.scss';

import { TextField } from "@mui/material";
import { setMail } from "../../../redux/slices/userSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { RootState } from "../../../app/store";

const ContactStep = () => {

    const dispatch = useAppDispatch();
    const { mail, isMailValid } = useAppSelector((state: RootState) => state.userSlice);

    return (
        <div className="order-mode_contact contact">
            <div className="contact_container">
                <div className="contact_wrapper">
                    <span className="contact_text">{Localized.SpanContactMailtext}</span>
                    <TextField 
                        size="small" 
                        error={!isMailValid}
                        helperText={!isMailValid && Localized.CheckpointCorrect}
                        placeholder="Начните писать тут..."
                        InputProps={{
                            style: {
                                background: "#fff",
                                borderRadius: '10px'
                            },
                        }}
                        value={mail}
                        onChange={(event) => dispatch(setMail(event.target.value))}
                        type="email"
                    />
                    {/* <p className="contact_checkbox_text">{Localized.CheckpointCorrect}</p> */}
                </div>
            </div>
        </div>
    );
}

export default ContactStep;